$(document).ready(function (e) {
    if ($(".js-top-page").length === 0) {
        return;
    }

    // Toggle
    $(".news-toggle").on("click", function () {
        $(this).find(".nursery-top__news-content").slideToggle();
        $(this).toggleClass("open");
    });
});
